'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require('../libs/axios');

var _axios2 = _interopRequireDefault(_axios);

var _cache = require('./cache');

var _cache2 = _interopRequireDefault(_cache);

var _util = require('../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

_axios2.default.defaults.withCredentials = true;

var tool = null;

/**
 * Model类
 */

var Model = function () {
  function Model() {
    _classCallCheck(this, Model);
  }

  _createClass(Model, null, [{
    key: 'want',


    /**
     * 1. 根据 fields 获取依赖 2. 格式化 fields
     * @param {string[]} fields 想获取的数据字段
     * @param {} instance 实例，只在实例调用才有
     * @returns this
     */
    // 默认请求缓存7天过期
    // 多 Model 配置
    // 主要用于打印table
    // 默认域
    value: function want() {
      var _this = this;

      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var instance = arguments[1];

      var mutiModelConfig = this.mutiModelConfig = this.mutiModelConfig || instance.mutiModelConfig;
      this.fields = (0, _util.normalizeArgs)(fields, 'string');

      if (mutiModelConfig && this.fields.length) {
        var common = mutiModelConfig.common,
            custom = mutiModelConfig.custom;

        //默认依赖，取 common 第一项

        var defaultDependency = Object.keys(common)[0];

        //收集fields里面显式依赖
        this.dependencies = [];

        this.fields = this.fields.map(function (field) {
          // common 符合格式字段
          if (field.indexOf('.') > -1) {
            _this.dependencies.push(field.split('.')[0]);
            return field;
          }
          // custom 字段
          if (custom && custom[field]) {
            _this.dependencies.push(custom[field]['dependencies']);
            return field;
          }
          // common 不符合格式字段，格式化
          _this.dependencies.push(defaultDependency);
          return defaultDependency + '.' + field;
        });
        // 去重
        this.dependencies = Array.from(new Set(this.dependencies));
      }

      return this;
    }

    /**
     * 拉取多Model请求
     * @param {*} config
     * @param {*} instance
     * @returns
     */
    // 依赖 ['basic', 'info']
    // 想要获取的字段
    // 接口返回结果

  }, {
    key: 'fetchAll',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        var _this2 = this;

        var _mutiModelConfig, common, custom, connectors;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _mutiModelConfig = this.mutiModelConfig, common = _mutiModelConfig.common, custom = _mutiModelConfig.custom;
                connectors = this.dependencies.map(function (dependencie) {
                  return common[dependencie]['connector'];
                });
                return _context.abrupt('return', new Promise(function (resolve) {
                  Promise.all(connectors.map(function (Connector) {
                    return Connector.fetch(config);
                  })).then(function (res) {
                    var result = {};
                    var resObj = {};
                    res.forEach(function (v, k) {
                      resObj[_this2.dependencies[k]] = v;
                    });
                    _this2.fields.forEach(function (field) {
                      // common
                      if (field.indexOf('.') > -1) {
                        var namespace = field.split('.')[0];
                        var key = field.split('.')[1];
                        var data = resObj[namespace];
                        if (key == '*') {
                          result[namespace] = data;
                        } else {
                          result[namespace] = result[namespace] || {};
                          result[namespace][key] = data.get(key, null);
                        }
                      } else {
                        // custom
                        result[field] = custom[field].compute(resObj);
                      }
                    });

                    resolve(result);
                  }).catch(function (err) {
                    console.error(err);
                    resolve(null);
                  });
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchAll(_x2) {
        return _ref.apply(this, arguments);
      }

      return fetchAll;
    }()

    /**
     * 请求接口
     * @param {*} config
     * @returns
     */

  }, {
    key: 'fetch',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, config) {
        var _this3 = this;

        var needPrefetchAPI, cacheKey, infoId, cache, beforeHooks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, hook;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._init();

              case 2:
                needPrefetchAPI = Model.needPrefetchAPI;
                cacheKey = '';
                _context3.prev = 4;

                if (!(needPrefetchAPI && needPrefetchAPI.includes(this.options.url))) {
                  _context3.next = 18;
                  break;
                }

                _cache2.default.cleanExpire();
                infoId = data.infoId;

                if (data.arg && data.arg.infoId) {
                  infoId = data.arg.infoId;
                }
                cacheKey = this.options.url + '?infoId=' + infoId;
                _context3.next = 12;
                return _cache2.default.get(cacheKey);

              case 12:
                cache = _context3.sent;

                if (!cache) {
                  _context3.next = 18;
                  break;
                }

                cache.get = Model.get;
                cache.result = cache;
                cache.usedCache = true;
                return _context3.abrupt('return', cache);

              case 18:
                _context3.next = 23;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3['catch'](4);

                console.log('model get cache error:', _context3.t0);

              case 23:

                // 局部更改 config
                data = this.handleOptions(data);

                if (!Model.globalConfig) {
                  _context3.next = 54;
                  break;
                }

                beforeHooks = (0, _util.normalizeArgs)(Model.globalConfig.beforeFetch, 'function');
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 29;
                _iterator = beforeHooks[Symbol.iterator]();

              case 31:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 40;
                  break;
                }

                hook = _step.value;

                if (!(typeof hook === 'function')) {
                  _context3.next = 37;
                  break;
                }

                _context3.next = 36;
                return hook.call(this, data, this, config);

              case 36:
                data = _context3.sent;

              case 37:
                _iteratorNormalCompletion = true;
                _context3.next = 31;
                break;

              case 40:
                _context3.next = 46;
                break;

              case 42:
                _context3.prev = 42;
                _context3.t1 = _context3['catch'](29);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 46:
                _context3.prev = 46;
                _context3.prev = 47;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 49:
                _context3.prev = 49;

                if (!_didIteratorError) {
                  _context3.next = 52;
                  break;
                }

                throw _iteratorError;

              case 52:
                return _context3.finish(49);

              case 53:
                return _context3.finish(46);

              case 54:
                return _context3.abrupt('return', new Promise(function (resolveOrigin) {
                  var resolve = function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(instance) {
                      var result, afterHooks, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _hook;

                      return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              if (!Model.globalConfig) {
                                _context2.next = 31;
                                break;
                              }

                              result = instance.result;
                              afterHooks = (0, _util.normalizeArgs)(Model.globalConfig.afterFetch, 'function');
                              _iteratorNormalCompletion2 = true;
                              _didIteratorError2 = false;
                              _iteratorError2 = undefined;
                              _context2.prev = 6;
                              _iterator2 = afterHooks[Symbol.iterator]();

                            case 8:
                              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                _context2.next = 17;
                                break;
                              }

                              _hook = _step2.value;

                              if (!(typeof _hook === 'function')) {
                                _context2.next = 14;
                                break;
                              }

                              _context2.next = 13;
                              return _hook.call(instance, result, instance);

                            case 13:
                              result = _context2.sent;

                            case 14:
                              _iteratorNormalCompletion2 = true;
                              _context2.next = 8;
                              break;

                            case 17:
                              _context2.next = 23;
                              break;

                            case 19:
                              _context2.prev = 19;
                              _context2.t0 = _context2['catch'](6);
                              _didIteratorError2 = true;
                              _iteratorError2 = _context2.t0;

                            case 23:
                              _context2.prev = 23;
                              _context2.prev = 24;

                              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                              }

                            case 26:
                              _context2.prev = 26;

                              if (!_didIteratorError2) {
                                _context2.next = 29;
                                break;
                              }

                              throw _iteratorError2;

                            case 29:
                              return _context2.finish(26);

                            case 30:
                              return _context2.finish(23);

                            case 31:
                              resolveOrigin(instance);

                            case 32:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this3, [[6, 19, 23, 31], [24,, 26, 30]]);
                    }));

                    return function resolve(_x5) {
                      return _ref3.apply(this, arguments);
                    };
                  }();
                  _axios2.default[_this3.options.type](_this3.options.url, data, config).then(function (res) {
                    _this3.response = res;
                    var result = res && res.data;
                    _this3.result.state = _this3.isSuccess() ? 'success' : 'fail';
                    // 请求成功，直接使用线上数据
                    if (_this3.result.state == 'success') {
                      _this3.result.data = _this3.handleData(result);
                      if (_util.isDevelopment) {
                        var key = _this3._getKey(_this3.options.url);
                        _cache2.default.set(key, _this3.result, _this3.expire);
                        _this3._printInfo();
                        _this3._updateTool();
                      }
                      try {
                        if (needPrefetchAPI && needPrefetchAPI.includes(_this3.options.url)) {
                          _cache2.default.set(cacheKey, _this3.result, _this3.prefetchExpire);
                        }
                      } catch (e) {
                        console.log('set cache error:', e);
                      }
                      resolve(_this3);
                    } else {
                      // 请求失败，尝试从本地拉取数据
                      _this3.result.error = _this3.handleError(result);
                      resolve(_this3.switchCache());
                    }
                  }).catch(function (res) {
                    _this3.result.error = {
                      errorCode: -9999,
                      errorMsg: '网络错误'
                    };
                    resolve(_this3.switchCache());
                  });
                }));

              case 55:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 20], [29, 42, 46, 54], [47,, 49, 53]]);
      }));

      function fetch(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return fetch;
    }()

    /**
     * 通过localforage，从本地获取数据
     */

  }, {
    key: 'switchCache',
    value: function switchCache() {
      var _this4 = this;

      if (!_util.isDevelopment) {
        return Promise.resolve(this);
      }
      var status = this.response.status;
      var data = this.response.data;

      if (Model.globalConfig && Model.globalConfig.needSwitchCache) {
        var needHooks = (0, _util.normalizeArgs)(Model.globalConfig.needSwitchCache, 'function');
        var needCache = needHooks.every(function (hook) {
          return hook.call(_this4, _this4.response, _this4);
        });
        if (!needCache) {
          return Promise.resolve(this);
        }
        if (Model.globalConfig) {
          // 开发环境下，不缓存请求白名单
          if (Model.globalConfig.whiteList) {
            var whiteListHooks = (0, _util.normalizeArgs)(Model.globalConfig.whiteList, 'string');
            var flag = whiteListHooks.some(function (white) {
              return _this4.options.url.includes(white);
            });
            if (flag) {
              return Promise.resolve(this);
            }
          }
          // 开发环境下，禁用缓存方法
          if (Model.globalConfig.disableCache) {
            var disableCacheHooks = (0, _util.normalizeArgs)(Model.globalConfig.disableCache, 'function');
            var _flag = disableCacheHooks.some(function (disableCache) {
              return disableCache(_this4);
            });
            if (_flag) {
              return Promise.resolve(this);
            }
          }
        }

        return new Promise(function (resolve) {
          var key = _this4._getKey(_this4.options.url);
          _cache2.default.get(key).then(function (result) {
            if (result) {
              _this4.options.online = false;
              _this4._updateTool(true);
              _this4.result = result;
            } else {
              _this4.options.online = true;
              _this4.result = {
                state: 'fail',
                data: null,
                error: _this4.result.error
              };
            }
            _this4._printInfo();
            resolve(_this4);
          }).catch(function () {
            _this4.options.online = true;
            _this4.result = {
              state: 'fail',
              data: null,
              error: _this4.result.error
            };
            _this4._printInfo();
            resolve(_this4);
          });
        });
      }

      if (status < 500 && data && data.respCode < 500) {
        return Promise.resolve(this);
      }

      if (Model.globalConfig) {
        // 开发环境下，不缓存请求白名单
        if (Model.globalConfig.whiteList) {
          var _whiteListHooks = (0, _util.normalizeArgs)(Model.globalConfig.whiteList, 'string');
          var _flag2 = _whiteListHooks.some(function (white) {
            return _this4.options.url.includes(white);
          });
          if (_flag2) {
            return Promise.resolve(this);
          }
        }
        // 开发环境下，禁用缓存方法
        if (Model.globalConfig.disableCache) {
          var _disableCacheHooks = (0, _util.normalizeArgs)(Model.globalConfig.disableCache, 'function');
          var _flag3 = _disableCacheHooks.some(function (disableCache) {
            return disableCache(_this4);
          });
          if (_flag3) {
            return Promise.resolve(this);
          }
        }
      }

      return new Promise(function (resolve) {
        var key = _this4._getKey(_this4.options.url);
        _cache2.default.get(key).then(function (result) {
          if (result) {
            _this4.options.online = false;
            _this4._updateTool(true);
            _this4.result = result;
          } else {
            _this4.options.online = true;
            _this4.result = {
              state: 'fail',
              data: null,
              error: _this4.result.error
            };
          }
          _this4._printInfo();
          resolve(_this4);
        }).catch(function () {
          _this4.options.online = true;
          _this4.result = {
            state: 'fail',
            data: null,
            error: _this4.result.error
          };
          _this4._printInfo();
          resolve(_this4);
        });
      });
    }
  }, {
    key: 'config',
    value: function config(_config) {
      this.options = _config;
    }

    /**
     * 兼容原来的版本
     * @param {*} options
     * @returns
     */

  }, {
    key: 'handleOptions',
    value: function handleOptions(options) {
      return options;
    }

    /**
     * 请求成功判断，优先判断白名单、然后全局钩子、最后isSuccess方法
     * @param {*} result
     * @returns
     */

  }, {
    key: 'isSuccess',
    value: function isSuccess() {
      var data = this.response.data;
      return data && [0].includes(+data.respCode);
    }

    /**
     * 数据处理
     * @param {*} result
     * @returns
     */

  }, {
    key: 'handleData',
    value: function handleData(result) {
      return result.respData;
    }

    /**
     * 错误处理
     * @param {*} result
     * @returns
     */

  }, {
    key: 'handleError',
    value: function handleError(result) {
      return {
        errorCode: result.respCode,
        errorMsg: result.errorMsg || result.errMsg || result.msg || (result.respData ? result.respData.errorMsg || result.respData.errMsg || result.respData.msg : '')
      };
    }

    /**
     * 安全获取数据
     * @param {*} path
     * @param {*} defaultValue
     * @returns
     */

  }, {
    key: 'get',
    value: function get(path) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (this.result && this.result.data !== null && this.result.data !== void 0) {
        var ans = (!Array.isArray(path) ? path.replace(/\[/g, '.').replace(/\]/g, '').split('.') : path).reduce(function (o, k) {
          return (o || {})[k];
        }, this.result.data);
        return ans === null || ans === void 0 ? defaultValue : ans;
      }
      return defaultValue;
    }

    /**
     * 初始化结果、this代理、参数格式化
     */

  }, {
    key: '_init',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this._resetResult();
                this._proxy();
                if (typeof this.options === 'function') {
                  this.isStatic = true;
                  this.options = this.options.call(this);
                }
                this.options.online = true;
                this.options.url = this._handleUrl(this.options.url);
                this.options.type = (this.options.type || 'get').toLowerCase();
                this._initTool();

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _init() {
        return _ref4.apply(this, arguments);
      }

      return _init;
    }()

    /**
     * 重置请求结果
     */

  }, {
    key: '_resetResult',
    value: function _resetResult() {
      this.result = {
        state: null,
        data: null,
        error: null
      };
      this.response = {};
    }

    /**
     * 代理 this.xxx 到 this.result.xxx
     */

  }, {
    key: '_proxy',
    value: function _proxy() {
      var _this5 = this;

      Object.keys(this.result).forEach(function (property) {
        Object.defineProperty(_this5, property, {
          get: function get() {
            return this.result[property];
          },

          configurable: true
        });
      });
    }

    /**
     * 短链接补齐
     * @param {*} url
     * @returns
     */

  }, {
    key: '_handleUrl',
    value: function _handleUrl(url) {
      if (typeof url !== 'string') return '';
      if (!(0, _util.containDomain)(url)) {
        url = this.baseURL + url;
      }
      return url;
    }

    /**
     * 获取 url 对应的 存储中的 key
     * @param {*} url
     * @returns
     */

  }, {
    key: '_getKey',
    value: function _getKey(url) {
      var key = url;
      if ((0, _util.containTimestamp)(url)) {
        var timestamp = (0, _util.getLikeTimestamp)(url);
        key = url.replace(timestamp, '');
      }
      return key;
    }

    /**
     * 初始化Tool工具，有使用缓存 亮起，点击清除缓存
     * @returns 
     */

  }, {
    key: '_initTool',
    value: function _initTool() {
      if (!_util.isDevelopment) {
        return;
      }
      tool = document.querySelector('.platform-cache-tool');
      if (tool) {
        return;
      }

      tool = document.createElement('div');
      tool.className = 'platform-cache-tool';
      var style = '\n      font-size: 10px; \n      color: #fff; \n      width: 35px; \n      height: 40px; \n      box-sizing: border-box; \n      padding: 5px;\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n    ';
      var template = '\n      <div \n        style="' + style + '">\n        <span>\u6E05\u9664</span>\n        <span>\u7F13\u5B58</span>\n      </div>\n    ';
      tool.enabled = false;
      tool.innerHTML = template;
      tool.style.position = 'fixed';
      tool.style.top = '200px';
      tool.style.zIndex = 999;
      tool.style.background = '#d8d8d8';
      tool.style.borderRadius = '0 20px 20px 0';

      // 拖拽逻辑开始
      var flag = 0; //标记是拖曳还是点击
      var disX = void 0,
          disY = void 0,
          L = void 0,
          T = void 0,
          moveY = void 0;
      /**
       * 触摸开始
       */
      tool.addEventListener('touchstart', function (e) {
        flag = 0;
        e.preventDefault(); //阻止触摸时页面的滚动，缩放
        disX = e.touches[0].clientX - this.offsetLeft;
        disY = e.touches[0].clientY - this.offsetTop;
      });

      /**
       * 按住移动
       */
      tool.addEventListener('touchmove', function (e) {
        flag = 1;
        L = e.touches[0].clientX - disX;
        T = e.touches[0].clientY - disY;
        //移动时 当前位置与起始位置之间的差值
        if (L < 0) {
          //限制拖拽的X范围，不能拖出屏幕
          L = 0;
        } else if (L > document.documentElement.clientWidth - this.offsetWidth) {
          L = document.documentElement.clientWidth - this.offsetWidth;
        }
        if (T < 0) {
          //限制拖拽的Y范围，不能拖出屏幕
          T = 0;
        } else if (T > document.documentElement.clientHeight - this.offsetHeight) {
          T = document.documentElement.clientHeight - this.offsetHeight;
        }
        moveY = T + 'px';
        this.style.left = 0;
        this.style.top = moveY;
      });

      /**
       * 触摸停止
       */
      tool.addEventListener('touchend', function () {
        // 点击
        if (tool.enabled && flag === 0) {
          _cache2.default.clear().then(function () {
            tool.style.background = '#d8d8d8';
            tool.enabled = false;
            window.alert('清除缓存成功');
          }).catch(function () {
            window.alert('清除缓存失败，请重试');
          });
        }
      });

      /**
       * 刷新重置
       */
      window.addEventListener('beforeunload', function (e) {
        tool.style.background = '#d8d8d8';
        tool.enabled = false;
        _cache2.default.remove('enabled');
      });
      var body = document.body;
      if (body) {
        body.append(tool);
      }
    }

    /**
     * 更新工具状态
     * @param {*} enable 
     */

  }, {
    key: '_updateTool',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var enabled;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _cache2.default.get('enabled');

              case 2:
                enabled = _context5.sent;

                if (enable && !enabled) {
                  tool.style.background = '#ff3333';
                  tool.enabled = true;
                  _cache2.default.set('enabled', true);
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _updateTool() {
        return _ref5.apply(this, arguments);
      }

      return _updateTool;
    }()

    /**
     * 表格打印接口信息，只在开发环境打印
     */

  }, {
    key: '_printInfo',
    value: function _printInfo() {
      if (!_util.isDevelopment) {
        return;
      }
      if (!this.options.online) {
        var theme = 'red';
        console.group('>>>>>>>>> 接口信息 >>>>>>>>>');
        console.log('%c \u6570\u636E\u6765\u6E90\uFF1A' + (this.options.online ? '接口' : '缓存'), 'color: ' + theme);
        console.log('%c ' + this.options.type.toUpperCase() + ' ' + /https?:\/\/(www\.)?\w+\.([^\/]+)(.*)/.exec(this.options.url)[3] + ' ' + this.response.status + ' ' + (this.response.data && this.response.data.respCode), 'color: ' + theme);
        console.log('%c response\uFF1A', 'color: ' + theme, this.result.data);
        console.log('\n\n');
        console.groupEnd();
      }
    }
  }]);

  return Model;
}();

// 需要dispatch到类上的方法


Model.baseURL = 'https://app.zhuanzhuan.com';
Model.result = {};
Model.response = {};
Model.fields = [];
Model.mutiModelConfig = null;
Model.dependencies = [];
Model.expire = 1000 * 60 * 60 * 24 * 7;
Model.globalConfig = {};
Model.options = {};
Model.prefetchExpire = 1000 * 5;
Model.usedCache = false;
Model.needPrefetchAPI = [];
Model.isStatic = false;
exports.default = Model;
var NEED_DISPATCH_METHODS = ['fetch', 'config', 'get', 'want', 'fetchAll'];

// 需要反射到原型上的方法
var NEED_REFLECT_METHODS = ['handleData', 'handleError', 'isSuccess', 'handleOptions'];

NEED_DISPATCH_METHODS.forEach(function (method) {
  Model.prototype[method] = function () {
    var _this6 = this;

    var SubModel = this.constructor;
    // 只挂载一次，如果原型上挂载了相应方法，静态调用的时候 指向原型方法
    NEED_REFLECT_METHODS.forEach(function (reflectMethod) {
      if (_this6[reflectMethod]) {
        SubModel[reflectMethod] = _this6[reflectMethod];
      }
    });

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return SubModel[method].apply(SubModel, args.concat([this]));
  };
});